module.exports = __webpack_public_path__ + "img/product_sk-ii_5.1087fde8.png";